import type { TierId } from './affiliateCommission';
import type { PartnerRole } from './mockData';

export const PARTNER_PORTAL_PATH = '/affiliate/partner-hub';
export const portalUrl = (tier?: TierId) => (tier ? `${PARTNER_PORTAL_PATH}?tier=${tier}` : PARTNER_PORTAL_PATH);

/** Agency managers and their agents/sub-agents share the agency's partner ID; members are told apart by agent ID. */
export const AGENCY_PARTNER_ID = 'BST-AGY-20480';
export const INFLUENCER_PARTNER_ID = 'BST-INF-20481';
export const partnerIdFor = (role: PartnerRole) => (role === 'influencer' ? INFLUENCER_PARTNER_ID : AGENCY_PARTNER_ID);

export const referralUrl = (partnerId: string, campaign?: string) =>
  `https://beststaytravels.com/?ref=${partnerId}${campaign ? `&campaign=${campaign}` : ''}`;
